<p-dialog [header]="modalHeader" [(visible)]="modalDisplay" [modal]="true" appendTo="body" (onHide)="hideModal()">
    <div *ngIf="displayImagePreview"> 
        <img class="img" [src]="currentFileLink" alt="Image not loaded. Please try again."/>
    </div>
    <div *ngIf="!displayImagePreview" class="document-previwer">
        <ngx-doc-viewer 
            *ngIf="!displayImagePreview"
            [viewer]="currentViewer"
            [url]="currentFileLink" 
            style="height:100%; width:100%;">
        </ngx-doc-viewer>
    </div>
    <!-- <div *ngIf="displayImagePreview" class="p-buttonset">
        <button pButton type="button" class="p-button-outlined" icon="pi pi-search-minus">
        </button>
        <button pButton type="button" class="p-button-outlined" icon="pi pi-search-plus">
        </button>
    </div> -->
</p-dialog>